import React from 'react';
import {Col, Button, Row} from 'adminlte-2-react';

require('../layout/Layout.css');

function SearchFilterContainer({
  child,
  addButtonText,
  onAdd,
  showAddButton = false,
}) {
  return (
    <Row className="section noMargin">
      <Col md={showAddButton ? 9 : 12}>{child}</Col>
      {showAddButton && (
        <Col md="3">
          <Button
            type="primary"
            icon="fas-plus"
            text={addButtonText}
            pullRight={true}
            onClick={onAdd}
          />
        </Col>
      )}
    </Row>
  );
}

export {SearchFilterContainer};
